export default __webpack_public_path__ + "static/media/003-bat.66f782be.svg";